// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"408":"32f68444","800":"29889829"}[chunkId] + ".chunk.css";
};